// extracted by mini-css-extract-plugin
export default {"quantity":"Quantity_quantity__NxcI-","current":"Quantity_current__bNDRc","max":"Quantity_max__YbDEJ"};